import type { TicketElement } from '../TicketElement'

export class EmptySeparator implements TicketElement {
  lineHeight: number

  constructor({ lineHeight }: { lineHeight?: number } = {}) {
    this.lineHeight = lineHeight ?? 22
  }

  height(): number {
    return this.lineHeight
  }

  render(): void {
    // No render, just space
  }
}
